import Service from "./Service";
const baseurl = '/api/historia-instrumento';
export default {
    index(params = {}) {
        return Service.get(`${baseurl}`, {
            params : params
        });
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByHcI(id_historia,id_instrumento) {
        return Service.get(`${baseurl}/show-by-hci/${id_historia}/${id_instrumento}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    showLast(id_usuario,id_instrumento) {
        return Service.get(`${baseurl}/show-last/${id_usuario}/${id_instrumento}`);
    },
}